module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm8": "",
      "offset-sm2": "",
      "lg4": "",
      "offset-lg4": ""
    }
  }, [_c('v-card', [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.busy),
      expression: "busy"
    }],
    staticClass: "text-xs-center",
    staticStyle: {
      "position": "absolute",
      "z-index": "2",
      "background-color": "rgba(255,255,255,1)",
      "width": "100%",
      "height": "100%"
    }
  }, [_c('v-layout', {
    attrs: {
      "align-center": "",
      "justify-center": "",
      "row": "",
      "fill-height": ""
    }
  }, [_c('v-flex', [_c('v-progress-circular', {
    attrs: {
      "indeterminate": "",
      "color": "primary"
    }
  }), _vm._v(" "), _c('div', [_c('h1', {
    staticClass: "headline mt-4 mt-4",
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("Loading, please wait...")])])], 1)], 1)], 1), _vm._v(" "), _c('v-layout', {
    staticStyle: {
      "height": "250px"
    },
    attrs: {
      "align-center": "",
      "justify-center": "",
      "row": "",
      "fill-height": ""
    }
  }, [_c('v-flex', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('v-icon', {
    staticStyle: {
      "color": "green",
      "font-size": "70px"
    },
    domProps: {
      "innerHTML": _vm._s('check_circle_outline')
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "font-size": "20px",
      "margin-top": "10px"
    }
  }, [_vm._v("Payment successful!")])], 1)], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3d67802b","transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/booking/pay_success.vue
// module id = FCyE
// module chunks = 1